import { useEffect, useRef } from 'react';

const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const useAutoSync = (intervalMinutes: number = 5) => {
  const syncIntervalRef = useRef<number | null>(null);

  const syncNotionToSupabase = async () => {
    try {
      const response = await fetch(
        `${SUPABASE_URL}/functions/v1/sync-notion-to-supabase`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Synchronisation automatique réussie:', data);
        
        // Stocker la dernière synchronisation
        localStorage.setItem('lastSync', new Date().toISOString());
        
        return data;
      } else {
        console.error('❌ Erreur de synchronisation:', await response.text());
      }
    } catch (error) {
      // Synchronisation silencieuse - pas de log d'erreur bruyant
    }
  };

  useEffect(() => {
    // Synchronisation immédiate au chargement
    const lastSync = localStorage.getItem('lastSync');
    const now = new Date().getTime();
    
    if (!lastSync || now - new Date(lastSync).getTime() > intervalMinutes * 60 * 1000) {
      syncNotionToSupabase();
    }

    // Synchronisation périodique
    syncIntervalRef.current = window.setInterval(() => {
      syncNotionToSupabase();
    }, intervalMinutes * 60 * 1000);

    // Nettoyage
    return () => {
      if (syncIntervalRef.current) {
        clearInterval(syncIntervalRef.current);
      }
    };
  }, [intervalMinutes]);

  return { syncNow: syncNotionToSupabase };
};
